module.exports = __webpack_public_path__ + "img/spongebob_squarepants_episode-editted.1b3c437d.jpg";